export default __webpack_public_path__ + "static/media/675.56db6fed.png";